// Local translations
export const T = {
  en_GB: {
    addCustomInstument: "Add Custom Instrument",
    editCustomInstument: "Edit Custom Instrument",
    addCustomInstumentDescription: "Fill in the details to add a new custom instrument.",
    editCustomInstumentDescription: "Update the custom instrument information below.",
    name: "Name",
    namePlaceholder: "e.g., OSEBX Index",
    ticker: "Ticker",
    tickerPlaceholder: "e.g., OSEBX",
    currency: "Currency",
    selectCurrency: "Select currency",
    cancel: "Cancel",
    addCustomInstrument: "Add Custom Instrument",
    save: "Save",
    loading: "Loading...",
    failedToSave: "Failed to save custom instrument",
    timeSeries: "Historical data",
    timeSeriesPlaceholder: `e.g.,
2026-01-06;102.5
2026-01-07;104.3
2026-01-08;103.1`,
    invalidCsvStructure: "Invalid CSV.",
    fileCsvStructure:
      "CSV must start with a header row `Date;Value` (or `Date,Value`), then one `date;value` or `date,value` per line (e.g. 2026-01-06;102.5). Date format: yyyy-mm-dd or dd/mm/yyyy. Delimiter: `;` or `,`. Decimal separator: `.` or `,`.",
    textCsvStructure: "Enter one `date;value` per line (e.g. 2026-01-06;102.5). No header needed.",
  },
  nb_NO: {
    addCustomInstument: "Legg til egendefinert instrument",
    editCustomInstument: "Rediger egendefinert instrument",
    addCustomInstumentDescription:
      "Fyll inn detaljene for å legge til et nytt egendefinert instrument.",
    editCustomInstumentDescription:
      "Oppdater informasjonen om det egendefinerte instrumentet nedenfor.",
    name: "Navn",
    namePlaceholder: "f.eks. OSEBX-indeks",
    ticker: "Ticker",
    tickerPlaceholder: "f.eks. OSEBX",
    currency: "Valuta",
    selectCurrency: "Velg valuta",
    cancel: "Avbryt",
    addCustomInstrument: "Legg til egendefinert instrument",
    save: "Lagre",
    loading: "Laster...",
    failedToSave: "Kunne ikke lagre egendefinert instrument",
    timeSeries: "Historiske data",
    timeSeriesPlaceholder: `f.eks.,
2026-01-06;102.5
2026-01-07;104.3
2026-01-08;103.1`,
    invalidCsvStructure: "Ugyldig CSV.",
    fileCsvStructure:
      "CSV må starte med en topprad `Date;Value` (eller `Date,Value`), deretter én `dato;verdi` eller `dato,verdi` per linje (f.eks. 2026-01-06;102.5). Datoformat: yyyy-mm-dd eller dd/mm/yyyy. Skilletegn: `;` eller `,`. Desimaltegn: `.` eller `,`.",
    textCsvStructure:
      "Skriv inn én `dato;verdi` per linje (f.eks. 2026-01-06;102.5). Topprad er ikke nødvendig.",
  },
} as const;
